import { requestService as api } from "../Request.service"  
const API_URL = { 
  API_MANAGE: `/ERP/goodsreceipt/manage.php`, 
  API_SEARCH: `/ERP/goodsreceipt/search.php`, 

  API_GETCODE: `/ERP/goodsreceipt/get-doc-code.php`,
  API_QC: `/ERP/goodsreceipt/gr-qc.php`,
  API_TAGS: `/ERP/goodsreceipt/gr-tags.php`,
  API_RECEIVE_STATUS: `/ERP/goodsreceipt/receive-status.php`,
  API_ITEMS_ALL: `/ERP/goodsreceipt/items-all.php`,
};
  
const GoodReceiptService = () => { 
  
  const create = (parm = {}) => api.post(`${API_URL.API_MANAGE}`, parm);
  const update = (parm = {}) => api.put(`${API_URL.API_MANAGE}`, parm);
  const deleted = (code) => api.delete(`${API_URL.API_MANAGE}?code=${code}`);
  const get = (code) => api.get(`${API_URL.API_MANAGE}?code=${code}`);

  const code = () => api.get(`${API_URL.API_GETCODE}`);

  const search = (parm = {}, config = {}) => api.post(`${API_URL.API_SEARCH}`, parm, {...config, cancle: true});

  const qcGet  = (code) => api.get(`${API_URL.API_QC}?code=${code}`);
  const qcSave = (parm = {}) => api.post(`${API_URL.API_QC}`, parm);
  /* รายการใบรับสินค้าทั้งหมดของวันที่เลือก (ใช้กับ Print รายวัน) */
  const qcByDate = (date) => api.get(`${API_URL.API_QC}?date=${date}`);

  /* ยกเลิกการรับเข้า / ยืนยันรับสินค้าอีกครั้ง */
  const cancelReceive  = (grcode, remark = "") =>
    api.post(`${API_URL.API_RECEIVE_STATUS}`, { grcode, remark, action: "cancel" });
  const confirmReceive = (grcode) =>
    api.post(`${API_URL.API_RECEIVE_STATUS}`, { grcode, action: "confirm" });

  /* รายการสินค้าทั้งหมด ใช้ตอนรับของโดยไม่มีใบสั่งซื้อ */
  const itemsAll = (q = "") =>
    api.get(`${API_URL.API_ITEMS_ALL}?q=${encodeURIComponent(q)}`, { ignoreLoading: true });

  const tagsGet  = (code) => api.get(`${API_URL.API_TAGS}?code=${code}`);
  const tagsSave = (parm = {}) => api.post(`${API_URL.API_TAGS}`, parm);

  return {
    create,
    update,
    deleted,
    get,

    code,

    search,

    qcGet,
    qcSave,
    qcByDate,

    tagsGet,
    tagsSave,

    itemsAll,

    cancelReceive,
    confirmReceive,
  };
};

export default GoodReceiptService;